export const reverseShape = (shape: object) => {
    return Object.entries(shape)
        .reverse()
        .reduce((prev, [key, value]) => ({ ...prev, [key]: value }), {})
}
